import { Carousel } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import classNames from 'classnames';
import {
  BUSINESS_TYPE_ENUM,
  SkuGalleryLabelCount,
} from 'domains/gallerySkuDomain';
import { random } from 'lodash-es';
import { useHistory } from 'react-router';
import { startJobConfigWithGalleryLabel } from 'utils/gallery';
import { getOS } from 'utils/os';
import './GallerySlick.less';

interface TypeColor {
  name: string;
  color: string;
}

const settings = {
  infinite: false,
  speed: 500,
  slidesToShow: 10,
  slidesToScroll: 1,
};

const GallerySlickItem = ({ item }: { item: SkuGalleryLabelCount }) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  let styleItem = typeColorMap.find(
    (typeItem) => item.skuLabel.name === typeItem.name
  );
  if (!styleItem) {
    styleItem = typeColorMap[random(0, typeColorMap.length - 1)];
  }
  const nameChar = item.skuLabel.name.charAt(0).toLowerCase();
  // const count = item.skuCount;

  return (
    <div
      key={item.skuLabel.id}
      className={classNames('gallery-slick-item', {})}
      onClick={() => {
        startJobConfigWithGalleryLabel(dispatch, item, history);
      }}
    >
      <div
        className="gallery-slick-item-symbol"
        style={{ color: styleItem?.color }}
      >
        <div
          style={{ height: charHeightMap[nameChar] || charHeightMap.default }}
        >
          {nameChar}
        </div>
      </div>
      <div className="gallery-slick-item-name">
        {item.skuLabel.name}
        {/* {count !== undefined ? `(${count})` : ''} */}
      </div>
    </div>
  );
};

export const GallerySlick = () => {
  const galleryLabels = useAppSelector((state) => state.gallery.galleryLabels);
  function onChange() {}

  return (
    <div
      className={classNames('gallery-slick', {
        windows: getOS() === 'windows',
      })}
    >
      <Carousel
        afterChange={onChange}
        {...settings}
        dots={false}
        arrows={true}
        slidesToScroll={4}
      >
        {galleryLabels
          .filter(
            (item) =>
              !item.skuLabel.parentId &&
              item.skuCount > 0 &&
              item.skuLabel.active &&
              !item.skuLabel.businessTypes.includes(
                BUSINESS_TYPE_ENUM.MY_COMPANY
              )
          )
          .map((item) => {
            const skuLabel = item.skuLabel;
            return <GallerySlickItem key={skuLabel.id} item={item} />;
          })}
      </Carousel>
    </div>
  );
};

const typeColorMap: TypeColor[] = [
  { name: 'Posters', color: '#B1D679' },
  { name: 'Decals', color: '#F392B3' },
  { name: 'Bookmarks', color: '#B261A4' },
  { name: 'Single-Page Documents', color: '#F3738A' },
  { name: 'Self Mailers', color: '#67B860' },
  { name: 'Banners', color: '#B261A4' },
  { name: 'Table Tents', color: '#46BAEB' },
  { name: 'Business Cards', color: '#F3738A' },
  { name: 'Newsletters', color: '#38C995' },
  { name: 'Pre-Cut sheet Labels', color: '#78C8AD' },
  { name: 'Sell Sheets', color: '#B261A4' },
  { name: 'Envelopes', color: '#46BAEB' },
  { name: 'Cut to size Labels', color: '#FAA556' },
  { name: 'Carbonless Forms', color: '#FF7D5C' },
  { name: 'Door Hangers', color: '#B261A4' },
  { name: 'Tickets', color: '#6462F6' },
  { name: 'Cards', color: '#52B3A7' },
  { name: 'Tags', color: '#38C995' },
  { name: 'Letterhead', color: '#F392B3' },
  { name: '3 Ring Binders', color: '#FAA556' },
  { name: 'Booklets', color: '#F3739E' },
  { name: 'Multi-Page Documents', color: '#67B860' },
  { name: 'Letters', color: '#FF7D5C' },
  { name: 'Postcards', color: '#78C8AD' },
  { name: 'Hang Tags', color: '#38C995' },
  { name: 'Magnetic Signs', color: '#F392B3' },
  { name: 'Flyers', color: '#6462F6' },
  { name: 'Rigid Signs', color: '#5A87EC' },
  { name: 'Brochures', color: '#FAA556' },
  { name: 'Roll Labels', color: '#5A87EC' },
  { name: 'Pocket Folders', color: '#F392B3' },
  { name: 'Notepads', color: '#0AD6C9' },
  { name: 'Menus', color: '#FFCB13' },
  { name: 'Tabs', color: '#F392B3' },
  { name: 'Catalogs', color: '#78C8AD' },
];

const charHeightMap: { [index: string]: number } = {
  default: 60,
  b: 48,
  d: 48,
  p: 70,
  t: 55,
  l: 48,
  3: 48,
  f: 48,
};
